import "./css/SigningFlow.css";
import { STEPS } from "../constants/steps";

export default function GuardianConsentRequiredScreen({
    flowData,
    updateFlowData,
    flowContext,
    updateFlowContext,
    next,
    back,
    loading,
    setLoading,
    error,
    setError,
}) {

    const goBack = () => {
        if (loading) return;
        setError("");
        next({
            action: "return_to_profile_selection"
        });
    };

    const continueToNext = () => {
        if (loading) return;
        setError("");
        next({
            action: "proceed_to_guardian_details"
        });
    };
    
    return (
        <div className={`page ${loading ? "page-loading" : ""}`}>
            
            {loading && (
                <div className="loading-overlay">
                    Loading...
                </div>
            )}

            {error && (
                <div className="text-red-600 mt-2">
                    {error}
                </div>
            )}
            
            <div className="page-header">

                <h2 className="business-name">
                    {flowContext.selectedService?.name
                        ? `${flowContext.selectedService.name} at ${flowContext.business?.businessName}`
                        : flowContext.business?.businessName}
                </h2>

            </div>

            <div className="page-content guardian-page">

                <div className="selected-service-icon guardian-icon" />

                <h3 className="guardian-title">
                    Guardian Consent Required
                </h3>

                <p className="guardian-text">
                    Because you are under 18, a parent or legal
                    guardian must provide consent for services at
                    <br />
                    {flowContext.business?.businessName || "[Business Name]"}.
                </p>

                <p className="guardian-text">
                    You will not sign the waiver yourself. Your
                    parent or legal guardian will review and sign it
                    on your behalf.
                </p>

                <p className="guardian-text">
                    Please generate and share the consent link with your parent or legal guardian to continue.
                </p>

            </div>

            <button
                className="back-button"
                onClick={goBack}
            >
                Back
            </button> 

            <div className="page-footer">

                <button
                    className="primary-button"
                    onClick={continueToNext}
                >
                    Generate consent link
                    <span className="button-arrow">›</span>
                </button>

                <div className="powered-by">
                    Powered by <strong>DidYouSign</strong>
                </div>

            </div>

        </div>
    );
}